import { render } from "./CustomNavbar.vue?vue&type=template&id=34f7d0b3&scoped=true"
import script from "./CustomNavbar.vue?vue&type=script&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&lang=js"

import "./CustomNavbar.vue?vue&type=style&index=0&id=34f7d0b3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f7d0b3"]])

export default __exports__